@use "../../sass/global/global" as *;

:host {
    display: flex;
    align-items: center;

    ux-icon[name="checkmark"] {
        color: $color-green;
        font-size: 18px;
        margin-right: 10px;
    }

    ux-icon[name="cross"] {
        color: $color-gray-40;
        font-size: 15px;
        margin-right: 10px;
    }

    .tooltip {
        display: flex;
        align-items: center;
        margin-left: 15px;
    }

    .label {
        color: $color-gray-40;
    }
}

:host([is-active]:not([is-active="false"])) {
    .label {
        color: $color-black-dark;
    }
}

::slotted(p) {
    margin: 0;
}
